<script>
import { Doughnut } from 'vue-chartjs'
import 'chartjs-plugin-doughnutlabel';

export default {
  extends: Doughnut,
  props: ['chartdata'],
  data : function() {
    return {
      options : {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 90,
        tooltips: {
            enabled: false
        },
        legend: {
          display: false
        },

        plugins: {
          doughnutlabel: {},
          outlabels : false
        }	


      },
      labels : {
        desejavel     : "Desejável",
        toleravel     : "Tolerável",
        indesejavel   : "Indesejável"
      },
      colors : {
        desejavel     : "#4CAF50",
        toleravel     : "#FF9800",
        indesejavel   : "#C62828"
      }
    }
  },
  mounted () {
    const chartData = {
      datasets: [{
        data: [this.chartdata.data.percent, (100 - parseFloat(this.chartdata.data.percent))],
        backgroundColor: [
          this.colors[this.chartdata.type],
          "#f1f1f1",
        ],
        hoverBackgroundColor: [
          this.colors[this.chartdata.type],
          "#f1f1f1",
        ],
        borderWidth: [
            0, 0
        ]
      }]
    };

    this.options.plugins.doughnutlabel = {
      labels: [
        {
          text: this.chartdata.data.percent+"%",
          font: {
            size: '30'
          }
        },
        {
          text: this.labels[this.chartdata.type],
          font: {
            size: '20'
          }
        },
      ]
    }

    this.renderChart(chartData, this.options);
  }
}
</script>

<style>
</style>